import { t } from "../translates/translate"

const getData = () => [
    { name: "dashboard", text: t("menu.dashboard"), link: "/", image: <img src="/images/home.png" alt="Home" /> },
    { name: "game", text: t("menu.game"), link: "/game", image: <img src="/images/spade.png" alt="Spade" /> },
    { name: "player", text: t("menu.player"), link: "/player", image: <img src="/images/user.png" alt="User" /> },
    { name: "studio", text: t("menu.studio"), link: "/studio", image: <img src="/images/light.png" alt="User" /> },
    { name: "bonus", text: t("menu.bonus"), link: "/bonus", image: <img src="/images/jackpot.png" alt="Chat" /> },
    { name: "message", text: t("menu.message"), link: "/message", image: <img src="/images/chat.png" alt="Chat" /> },
    { name: "space" },
    { name: "currency", text: t("menu.currency"), link: "/currency", image: <img src="/images/dollar.png" alt="Dollar" />, superadmin: true },
    { name: "card", text: t("menu.card"), link: "/card", image: <img src="/images/cards.png" alt="Cards" />, superadmin: true },
    { name: "dealer", text: t("menu.dealer"), link: "/dealer", image: <img src="/images/croupier.png" alt="Croupier" /> },
    { name: "space" },
    { name: "user", text: t("menu.users"), link: "/user", image: <img src="/images/avatar.png" alt="Avatar" />, extended: true },
    { name: "user", text: t("menu.operators"), link: "/operator", image: <img src="/images/avatar.png" alt="Avatar" />, superadmin: true },
    { name: "role", text: t("menu.roles"), link: "/role", image: <img src="/images/permission.png" alt="Permission" />, superadmin: true },
]

export { getData }
